import { Routes } from '@angular/router'
import { LatestmoviesComponent } from './latestmovies/latestmovies.component'
import { MoviesearchComponent } from './moviesearch/moviesearch.component'
import { FullmovieComponent } from './fullmovie/fullmovie.component'
import { FavoritesComponent } from './favorites/favorites.component'
export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: LatestmoviesComponent },
    { path: 'search', component: MoviesearchComponent },
    { path: 'movie/:id', component: FullmovieComponent },
    { path: 'favorites', component: FavoritesComponent }
]